import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ComplianceWorkspacePage = lazy(
  () => import("@/features/dashboard/pages/compliance-workspace"),
);

export const Route = createFileRoute("/(app)/dashboard/compliance-workspace")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading Compliance Workspace...</div>}>
      <ComplianceWorkspacePage />
    </Suspense>
  ),
});
